export default __webpack_public_path__ + "static/media/sustentabilidade.b3469ce6.png";